import {
  ADD_DATA_TABLE_KNOWELEDGE_TEST_RECORD,
  CLEAR_STATE_KNOWELEDGE_TEST_RECORD,
  GET_DATA_BY_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD,
  GET_DATA_PEOPLE_BY_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD,
  SET_DATA_FOR_EDIT_KNOWELEDGE_TEST_RECORD,
  SET_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD,
  SET_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD_SEARCH_PEOPLE,
  UPDATE_DATA_PEOPLE_TABLE_KNOWELEDGE_TEST_RECORD,
  UPDATE_EDITABLE_TABLE_DATA_KNOWELEDGE_TEST_RECORD,
  UPDATE_INPUT_DATA_KNOWELEDGE_TEST_RECORD,
  UPDATE_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD,
} from "../types";

const initialState = {
  dataMain: {},
  dataForSearchTable: [],
  dataForTable: [],
  searchParams: {
    surname: "",
    name: "",
    midname: "",
    birthDate: "",
    section: 0,
    programId: 0,
    e1PassName: 0,
    e2PassName: 0,
    checkPassName: 0,
    protNum: "",
    protDate: "",
  },
  searchParamsForPeople: {
    surname: "",
    name: "",
    midname: "",
    birthDate: "",
    currentProtDate: "",
    programId: 0,
    protDate: "",
    selfTraining: 0,
  },
  dataPeopleForTable: [],
};

export const knowledgeTestRecordReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD_SEARCH_PEOPLE: {
      return {
        ...state,
        searchParamsForPeople: Object.assign(state.searchParamsForPeople, action.data),
      };
    }
    case SET_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD: {
      return {
        ...state,
        searchParams: Object.assign(state.searchParams, action.data),
      };
    }
    case GET_DATA_BY_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD: {
      return {
        ...state,
        dataForSearchTable: action.data,
      };
    }
    case UPDATE_INPUT_DATA_KNOWELEDGE_TEST_RECORD:
      return {
        ...state,
        dataMain: { ...state.dataMain, ...action.data },
      };
    case UPDATE_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD: {
      return {
        ...state,
        searchParamsForPeople: Object.assign(state.searchParamsForPeople, action.data),
      };
    }
    case GET_DATA_PEOPLE_BY_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD: {
      return {
        ...state,
        dataPeopleForTable: action.data,
      };
    }
    case UPDATE_DATA_PEOPLE_TABLE_KNOWELEDGE_TEST_RECORD: {
      return {
        ...state,
        dataPeopleForTable: action.data,
      };
    }
    case ADD_DATA_TABLE_KNOWELEDGE_TEST_RECORD: {
      const summaryData = [...action.data, ...state.dataForTable];
      const validatedData = summaryData.reduce((acc, n) => {
        const i = acc.findIndex((m) => m.id === n.id);
        if (!~i) {
          acc.push(n);
          if (~i) {
            acc.splice(i, 1);
          }
        }
        return acc;
      }, []);

      return {
        ...state,
        dataForTable: validatedData,
      };
    }
    case UPDATE_EDITABLE_TABLE_DATA_KNOWELEDGE_TEST_RECORD: {
      return {
        ...state,
        dataForTable: action.data,
      };
    }
    case CLEAR_STATE_KNOWELEDGE_TEST_RECORD: {
      return {
        ...initialState,
      };
    }

    case SET_DATA_FOR_EDIT_KNOWELEDGE_TEST_RECORD: {
      return {
        ...state,
        dataMain: action.data.trainingCheckDataTotal,
        dataForTable: action.data.trainingCheckDataRecord,
      };
    }
    default:
      return state;
  }
};
